import { ProductTemplateOption } from '@/shared/components/PresetSelection/types.ts';

export const MANUAL_FULFILLMENT_OPTIONS: ProductTemplateOption[] = [
    // Material Inc Transport
    {
        productType: 'CUSTOM_BULK_MATERIAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
    },
    {
        productType: 'CUSTOM_RECYCLED_BULK_MATERIAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
    },
    {
        productType: 'CUSTOM_ASPHALT',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
    },
    {
        productType: 'CUSTOM_CONCRETE',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
    },
    {
        productType: 'CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
        formPreset: { disposalPurpose: 'RECYCLING' },
    },
    {
        productType: 'CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
        formPreset: { disposalPurpose: 'DISPOSAL' },
    },
    {
        productType: 'CUSTOM_HAZARDOUS_WASTE_RECYCLING',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
        formPreset: { disposalPurpose: 'RECYCLING' },
    },
    {
        productType: 'CUSTOM_HAZARDOUS_WASTE_DISPOSAL',
        isStandalone: false,
        pricingStrategies: ['FRANCO', 'MERCHANT', 'STANDARD'],
        formPreset: { disposalPurpose: 'DISPOSAL' },
    },

    // Transport Only
    {
        productType: 'CUSTOM_TRANSPORT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'HOUR' },
    },
    {
        productType: 'CUSTOM_TRANSPORT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'TON' },
    },
    {
        productType: 'CUSTOM_TRANSPORT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'TRANSPORT' },
    },

    // Material Only
    {
        productType: 'CUSTOM_BULK_MATERIAL',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
    },
    {
        productType: 'CUSTOM_RECYCLED_BULK_MATERIAL',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
    },
    {
        productType: 'CUSTOM_ASPHALT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
    },
    {
        productType: 'CUSTOM_CONCRETE',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
    },
    {
        productType: 'CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { disposalPurpose: 'RECYCLING' },
    },
    {
        productType: 'CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { disposalPurpose: 'DISPOSAL' },
    },
    {
        productType: 'CUSTOM_HAZARDOUS_WASTE_RECYCLING',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { disposalPurpose: 'RECYCLING' },
    },
    {
        productType: 'CUSTOM_HAZARDOUS_WASTE_DISPOSAL',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { disposalPurpose: 'DISPOSAL' },
    },

    // Service Only
    {
        productType: 'CUSTOM_SERVICE_ANALYSIS',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'PIECE' },
    },
    {
        productType: 'CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'PIECE' },
    },
    {
        productType: 'CUSTOM_SERVICE_TOLL',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'PIECE' },
    },
    {
        productType: 'CUSTOM_SERVICE_WAITING_TIME',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'HOUR' },
    },
    {
        productType: 'CUSTOM_SERVICE_TRANSPORT',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'TON' },
    },
    {
        productType: 'CUSTOM_SERVICE',
        isStandalone: true,
        pricingStrategies: ['STANDARD'],
        formPreset: { billingUnit: 'TON' },
    },
];
